module.exports = __webpack_public_path__ + "static/img/shiwusuo.8678e097.png";